<template>
    <div class="checkout-popup medium bg-white shadow-5 rounded">
        <h3 class="px my">{{ $t('_checkout.reviewOrder') }}</h3>
        <hr class="my-0" />
        <div class="px py">
            <p class="mt-0 mb">{{ $t('_checkout.checkEverything') }}:</p>
            <div class="frame mt-2 mb">
                <p class="d-flex mt-0">
                    <span class="checkout-popup-icon">
                        <i
                            v-if="
                                storeState.carrier.carrierId === 81027 ||
                                storeState.carrier.carrierId === 4
                            "
                            class="icon-cr icon-order-sent"
                        />
                        <i v-else class="icon-cr icon-carrier-car" />
                    </span>
                    <span>
                        <span
                            v-if="
                                storeState.carrier.carrierId === 81027 ||
                                storeState.carrier.carrierId === 4
                            "
                            v-html="$t('untilDateToXHtml', [formattedFinalForecast])"
                        />
                        <span v-else v-html="$t('dateToXHtml', [formattedFinalForecast])" />
                    </span>
                </p>
                <hr />
                <p class="d-flex">
                    <span class="checkout-popup-icon">
                        <i class="icon-cr icon-map-maker" />
                    </span>
                    <span v-if="storeState.carrier.carrierId === 81027 && pickupStore">
                        <strong>{{ pickupStore.name }}</strong>
                    </span>
                    <span v-else>
                        <strong>{{ cart.address.data.full_name }}</strong>
                        <span v-if="schoolBranchDelivery">
                            <br />Escola: <strong>{{ schoolBranchDelivery.school }}</strong>
                        </span>
                        <span v-else-if="cart.address.data.alias"
                            >&nbsp;({{ cart.address.data.alias }})</span
                        >
                    </span>
                </p>
                <p class="d-flex">
                    <span class="checkout-popup-icon" />
                    <span v-if="schoolBranchDelivery">
                        {{ $t('address') }}:
                        <strong
                            >{{ schoolBranchDelivery.address }}, {{ schoolBranchDelivery.number }} -
                            {{ schoolBranchDelivery.city }} / {{ schoolBranchDelivery.state }}
                        </strong>
                    </span>
                    <span v-else-if="storeState.carrier.carrierId === 81027 && pickupStore">
                        {{ $t('storeAddress') }}:
                        <span>
                            {{ pickupStore.address }}, {{ pickupStore.number }} -
                            <template v-if="pickupStore.complement">
                                {{ pickupStore.complement }} -
                            </template>
                            {{ pickupStore.neighborhood }} - {{ pickupStore.city }}/{{
                                pickupStore.uf
                            }}
                            - CEP
                            {{ pickupStore.cep }}
                        </span>
                    </span>
                    <span v-else>
                        {{ $t('address') }}:
                        <strong
                            >{{ cart.address.data.address_1 }}
                            <span
                                v-if="
                                    cart.address.data.city !== 'Brasília' &&
                                    !(
                                        cart.address.data.type_id === 1 &&
                                        cart.address.data.number === 0
                                    )
                                "
                                >, {{ cart.address.data.number }}</span
                            ><span
                                v-if="
                                    cart.address.data.additional_info &&
                                    cart.address.data.additional_info !== ''
                                "
                                >/ {{ cart.address.data.additional_info }}</span
                            >
                        </strong>
                        <br />
                        {{ cart.address.data.address_2 }} - {{ cart.address.data.city }} /
                        {{ cart.address.data.uf }} - CEP
                        {{ cart.address.data.zip_code }}
                    </span>
                </p>
                <template v-if="cart.total_paid > 0">
                    <hr />
                    <p class="d-flex mb-0">
                        <span class="checkout-popup-icon">
                            <i
                                :class="
                                    (storeState.payment.selectedMethod || {}).module ===
                                    'boleto_bancario'
                                        ? 'icon-info-product'
                                        : 'icon-credit-card'
                                "
                                class="icon-cr"
                            />
                        </span>
                        <span>
                            {{ $t('_checkout.paymentBy') }}:
                            <strong>
                                {{ storeState.payment.description }}
                            </strong>
                        </span>
                    </p>
                </template>
                <template
                    v-if="
                        cart.allow_organization_selection &&
                        cart.organization &&
                        cart.organization.data
                    "
                >
                    <hr />
                    <p class="d-flex mb-0">
                        <span class="checkout-popup-icon">
                            <i class="icon-cr icon-like" />
                        </span>
                        <span>
                            <strong>
                                {{ cart.organization.data.cart_message }}
                            </strong>
                        </span>
                    </p>
                </template>
            </div>
            <div class="px py" v-if="customer.tipo_pessoa === 1">
                <p class="mt-0 mb">
                    <strong>{{ $t('_checkout.messageImportant') }}</strong>
                    {{ $t('_checkout.messageCheckEmail') }}
                </p>
            </div>
            <span class="text-danger" v-if="hasCustomizableProduct"
                >Produtos personalizados não são passíveis de troca e / ou devolução, salvo em caso
                de defeitos de fabricação.</span
            >
            <div class="row">
                <div class="col-xs-6">
                    <button class="btn btn-light btn-wide" @click="$emit('hide')">
                        {{ $t('toChange') }}
                    </button>
                </div>
                <div class="col-xs-6">
                    <button class="btn btn-success btn-wide" @click="submit">
                        <span class="hidden-sm-up">
                            {{ $t('toFinish') }}
                        </span>
                        <span class="hidden-sm-down">{{ $t('_shop.toFinishOrder') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '../../script/store/checkout';

    export default {
        name: 'CheckoutReview',

        props: {
            pickupStore: {
                type: Object,
                required: false,
            },

            hasCustomizableProduct: {
                type: Boolean,
                required: true,
            },
        },

        data() {
            return {
                storeState: store.state,
            };
        },

        computed: {
            cart() {
                return store.state.cart.cart;
            },

            customer() {
                return (this.cart.customer || {}).data;
            },

            initialForecast() {
                return store.state.carrier.initialForecast;
            },

            finalForecast() {
                return store.state.carrier.finalForecast;
            },

            schoolBranchDelivery() {
                return store.state.carrier.schoolBranchDelivery;
            },

            formattedInitialForecast() {
                return this.initialForecast
                    ? `${this.$f.formatDate(this.initialForecast, 'DD')} de ${this.$f
                          .formatDate(this.initialForecast, 'MMMM')
                          .toUpperCase()}`
                    : null;
            },

            formattedFinalForecast() {
                return this.initialForecast
                    ? `${this.$f.formatDate(this.finalForecast, 'DD')} de ${this.$f
                          .formatDate(this.finalForecast, 'MMMM')
                          .toUpperCase()}`
                    : null;
            },
        },

        methods: {
            submit() {
                this.$emit('hide');
                this.$emit('checkout');
            },
        },
    };
</script>
